// creating the entity adapter
import { Organization } from '@models';
import { EntityState, createEntityAdapter } from '@ngrx/entity';
export interface OrganizationState extends EntityState<Organization> {
  isLoading: boolean;
}
export const organizationAdapter = createEntityAdapter<Organization>();
export const initialState: OrganizationState =
  organizationAdapter.getInitialState({ isLoading: false });
